<template>
  <StepLayout pageId="page-2" title="Choose a Time" contentId="selectTime-mod">
    <div class="choose-time-wrap">
      <p class="open-time-tip">Tell us your expected dining time so we can ensure a pleasant dining experience</p>
      <p class="open-time-tip open-time">
        {{ openTimeText }}
      </p>



      <div v-if="sessionList.length" class="session-button-group" role="group" aria-label="Reservation session">
        <button
          v-for="(item, index) in sessionList"
          :key="item.id || index"
          type="button"
          class="session-button"
          :class="{ active: isSessionActive(item, index) }"
          @click="handleSessionClick(item, index)"
        >
          {{ item.name || `Session ${index + 1}` }}
        </button>
      </div>

      <!-- <div class="start-time-label">Start Time</div> -->
      <a-select
        v-model="selectedTime"
        show-search
        placeholder="Select a Time"
        dropdown-class-name="select-time-dropdown"
        class="form-control time-select custom-a-select"
        _open="true"

        @change="handleTimeChange"
      >
        <a-select-option
          v-for="(item, index) in timeList"
          :key="`${item.time}-${index}`"
          :value="item.time"
        >
          {{ item.time }}
        </a-select-option>
      </a-select>
    </div>
  </StepLayout>
</template>

<script>
import StepLayout from "./StepLayout.vue";

export default {
  name: "ReservationStep2",
  components: {
    StepLayout
  },
  props: {
    sessionArr: [Array, String],
    selectedSessionNum: [Number, String],
    timeActive: Number,
    timeArr: [Array, String],
    currentTime: String
  },
  data() {
    return {
      selectedTime: undefined
    };
  },
  computed: {
    sessionList() {
      if (!Array.isArray(this.sessionArr)) {
        return [];
      }

      return this.sessionArr.filter(
        (item) => item && typeof item === "object" && Number(item.booking_switch) !== 0
      );
    },
    timeList() {
      if (!Array.isArray(this.timeArr)) {
        return [];
      }

      return this.timeArr.filter(
        (item) =>
          item &&
          typeof item.time === "string" &&
          item.time &&
          Number(item.show) === 1
      );
    },
    openTimeText() {
      const timeRanges = this.sessionList
        .map((item) => {
          const firstSeating = this.formatSessionTime(item.first_seating);
          const lastSeating = this.formatSessionTime(item.last_seating);

          if (!firstSeating || !lastSeating) {
            return "";
          }

          return `${firstSeating} to ${lastSeating}`;
        })
        .filter(Boolean);

      if (!timeRanges.length) {
        return "We're open from 10am to 2pm, and 5pm to 12pm.";
      }

      return `We're open from ${this.joinTimeRanges(timeRanges)}.`;
    }
  },
  watch: {
    currentTime: {
      immediate: true,
      handler(value) {
        this.selectedTime = value || undefined;
      }
    }
  },
  methods: {
    formatSessionTime(time) {
      if (typeof time !== "string" || !time) {
        return "";
      }

      return time.slice(0, 5);
    },
    joinTimeRanges(timeRanges) {
      if (timeRanges.length === 1) {
        return timeRanges[0];
      }

      if (timeRanges.length === 2) {
        return timeRanges.join(", and ");
      }

      return `${timeRanges.slice(0, -1).join(", ")}, and ${
        timeRanges[timeRanges.length - 1]
      }`;
    },
    isSessionActive(item, index) {
      if (this.selectedSessionNum) {
        return String(this.selectedSessionNum) === String(item.id);
      }

      return index === Number(this.timeActive || 0);
    },
    handleSessionClick(item, index) {
      if (this.isSessionActive(item, index)) {
        return;
      }

      this.$emit("sessionSelected", {
        session: item,
        index,
        sessionNum: item.id
      });
    },
    handleTimeChange(value) {
      const selectedItem = this.timeList.find((item) => item.time === value);

      this.$emit("timeSelected", {
        time: value,
        table_id: selectedItem ? selectedItem.table_id || "" : "",
        show: selectedItem ? selectedItem.show : 0
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.choose-time-wrap {
  .open-time-tip {
    text-align: left;
    font-size: 14px;
    color: #7B7D7F;
    margin-top: 20px;
    &.open-time {
      color: var(--brandColor);
    }
  }
  
  .time-select {
    width: 100%;
    margin-top: 20px;
  }

  .session-button-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 18px;
  }

  .session-button {
    appearance: none;
    border: 1px solid #f6f6f6;
    border-radius: 8px;
    background: #f6f6f6;
    color: #495057;
    cursor: pointer;
    font-size: 13px;
    line-height: 1.2;
    min-height: 36px;
    padding: 8px 12px;
  }

  .session-button:focus,
  .session-button:focus-visible,
  .session-button:active {
    border-color: #f6f6f6;
    box-shadow: none;
    outline: none;
  }

  .session-button.active {
    border-color: var(--brandColor);
    background: var(--brandColor);
    color: #fff;
  }

  .session-button.active:focus,
  .session-button.active:focus-visible,
  .session-button.active:active {
    border-color: var(--brandColor);
  }

  .start-time-label {
    color: #202020;
    text-align: left;
  }
}
</style>

<style>
/* 针对使用 a-select 的样式全局穿透覆盖，确保在组件内无缝展示 */
.custom-a-select.time-select {
  width: 100%;
  height: 50px;
  border: none !important;
  background-color: transparent !important;
  padding-left: 0;
  margin-top: 10px; /* 让下拉框和 label 有合理的间距 */
}

/* 覆盖内部真实的 selection 容器 */
.custom-a-select.time-select .ant-select-selection {
  height: 50px !important;
  padding-left: 10px !important; 
  border-radius: 8px !important;
  border-color: #f6f6f6 !important;
  background-color: #f6f6f6 !important;
  box-shadow: none !important;
}

.custom-a-select.time-select .ant-select-selection__rendered {
  line-height: 48px !important;
}

.custom-a-select.time-select .ant-select-arrow {
  right: 12px !important;
}

/* 下拉菜单控制，复用全局配置保证一致 */
.select-time-dropdown .ant-select-dropdown-menu-item {
  color: #495057;
  min-height: 46px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  display: flex;
  align-items: center;
}

.select-time-dropdown .ant-select-dropdown-menu-item:hover {
  background-color: #f6f6f6; /* 跟背景一致的柔和色调或者原生的微蓝都行，这里设为柔和 */
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationStep2.vue